import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getLocalKey } from '../../../utils/commonfunction';
import { setGlobalLoader } from '../../../redux/slices/globalLoader';
import { useDispatch, useSelector } from 'react-redux';
import GlobalLoader from './globalLoader';
import {ROLE} from '../../../utils/Constants'

const CenterPublicRoute = ({ component: Component }) => {
    const dispatch = useDispatch();
    const loaderState = useSelector((state) => state.globalLoader);

    const location = useLocation(); // Get current location
    
    const centerData = getLocalKey(ROLE.CENTER) ? JSON.parse(getLocalKey(ROLE.CENTER)) : {};
    const doctorData = getLocalKey(ROLE.DOCTOR) ? JSON.parse(getLocalKey(ROLE.DOCTOR)) : {};

    useEffect(() => {
        Promise.all([import('rsuite/dist/rsuite.min.css'),
        import('bootstrap/dist/css/bootstrap.min.css'),
        import("../../../assets/admin/plugins/fancyuploder/fancy_fileupload.css")]).then(() => {
            dispatch(setGlobalLoader(false));
        })
    }, []);

    // console.log("locationlocationlocationlocationlocationlocationlocationlocationlocation", location.pathname.includes("/center") && centerData && centerData.token && centerData?.role === ROLE.CENTER)
    // console.log("doctordoctordoctordoctordoctordoctordoctordoctordoctordoctor", location.pathname.includes("/doctor") && doctorData && doctorData.token && doctorData?.role === ROLE.DOCTOR)

    return (
        <>
            {
                (location.pathname.includes("/center") && centerData && centerData.token && centerData?.role === ROLE.CENTER) ? 
                    <Navigate to={{ pathname: "/center" }} />
                : (location.pathname.includes("/doctor") && doctorData && doctorData.token && doctorData?.role === ROLE.DOCTOR) ?
                    <Navigate to={{ pathname: "/doctor" }} />
                : loaderState ?
                    <GlobalLoader />
                :   <Component />
            }
        </>
    )

}

export default CenterPublicRoute;